module.exports = __webpack_public_path__ + "static/media/bus_selected.aebdaf8c.svg";